import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import common from "../../services/common.js";
import env from "../../services/env.js";
import messaging from "../../services/messagingv2.js";

class MessagingController {
  constructor(
    $http,
    $localStorage,
    $scope,
    $state,
    AuthService,
    EventsService,
    $stateParams,
    SecurityService,
    CommonService,
    $rootScope,
    EnvService,
    $timeout,
    $location,
    Messagingv2Service
  ) {
    this.name = "messaging";
    $localStorage.activeStateName = "messaging";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$location = $location;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$security = SecurityService;
    this.showGalleryForChat = false;
    this.defaultText = "Write your message...";
    this.$common = CommonService;
    this.$rootScope = $rootScope;
    this.setEnterCtrl = false;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.$messagingv2 = Messagingv2Service;
    this.getChatFirst = false;
    this.disable_send = false;
    this.composingNewChat = false;
    this.selection = [];
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 1;
    this.thereAreChatsForThisEvent = true;
    this.jobblersInDefaultChat = [];
    this.eventLocation = null;
    this.jobblersForNewChatFromChosen = [];
    this.checkAdminStatus();
    this.textareaText = this.defaultText;
    this.disablePostButton = false;

    var _this = this;
  }
}

MessagingController.$inject = [
  "$http",
  "$localStorage",
  "$scope",
  "$state",
  "auth",
  "events",
  "$stateParams",
  "security",
  "common",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
  "messagingv2",
];

export default MessagingController;



// WEBPACK FOOTER //
// ./client/app/components/messaging/messaging.controller.js